module.exports = __webpack_public_path__ + "static/media/dots.2cef56ad.svg";